$(document).ready(function () {  
  $(".hotwheels_intake_from_button .button").click(function (event) {
    event.preventDefault();
    $(this).addClass('btn-loading');
    const __this = $(this).closest('form');

    var formData = {
      name: $('input[name="contact[name]"]').val(),
      email: $('input[name="contact[email]"]').val(),
      bottleNumber1: $('#hotwheels-product-bottle-1').val(),
      bottleNumber2: $('#hotwheels-product-bottle-2').val(),
      message: $('textarea[name="contact[question]"]').val(),
    };
    // console.log("formData", formData);

    // Validate the form inputs
    var errorMessages = [];
    $('.error-message').html('');
    if (!formData.name) {
      errorMessages.push("Name cannot be empty.");
      $('.intake-name-error-message').html('Name cannot be empty.');
    }
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      errorMessages.push("Email cannot be empty.");
      $('.intake-email-error-message').html('Email cannot be empty.');
    } else if (!emailRegex.test(formData.email)) {
      errorMessages.push("Please enter a valid email address.");
      $('.intake-email-error-message').html('Please enter a valid email address.');
    }
    if (!formData.bottleNumber1 && !formData.bottleNumber2) {
      errorMessages.push("Please select at least one bottle option.");
      $('.intake-bottle-error-message').html('Please select at least one bottle option.');
    }

    if (errorMessages.length > 0) {
      $(this).removeClass('btn-loading');
      return;
    }

    // Google Apps Script URL
    var scriptURL = "https://script.google.com/macros/s/AKfycbxZelGIH123zWL3W940d0XQMSzXtM-X4olLIVr_xKs_wa89RFmp0nMzx6qFkimvrSUGPg/exec";

    // Send data to Google Sheets
    $.ajax({
      url: scriptURL,
      method: "POST",
      data: formData,
      success: function (response) {
        console.log("Data sent to Google Sheets: " + response);
        setTimeout(() => {
          $('.hotwheels_intake_from_button .button').removeClass('btn-loading');
        }, 3000);
        __this.submit();  // Submit the form to Shopify after data is sent to Google Sheets
      },
      error: function (error) {
        console.error("Error sending data to Google Sheets: " + error);
      },
    });
  });
});


let observer = new MutationObserver(checkForElement);
const config = { childList: true, subtree: true };
observer.observe(document.body, config);
function checkForElement() {
  let element = document.querySelector(".hotwheels_from_success");
  if (element) {
    setTimeout(function () {
      element.style.display = "none";
    }, 5000);
  }
}
